import { emulatorScreen, mobileScreen } from "../../utils/styleUtils";

const styles = (theme) => ({
  shape1Major: {
    width: 271,
    overflow: "hidden",
    top: 211,
    left: 39,
    position: "absolute",
    zIndex: 3,
    height: 68.5,
    // clipPath: "polygon(50% 100%, 50% 100%, 100% 0, 0 0)",
    // shapeOutside: "polygon(50% 100%, 50% 100%, 100% 0, 0 0)",

    [emulatorScreen(theme)]: {
      width: 177,
      top: 75,
      left: 29.5,
      height: 36,
    },
    [mobileScreen(theme)]: {
      width: 181,
      top: 73.5,
      left: 28.5,
      height: 36,
    },
  },

  shape2Major: {
    width: 141,
    overflow: "hidden",
    top: 208,
    left: 24,
    position: "absolute",
    zIndex: 3,
    height: 71.5,
    clipPath: "polygon(0 0, 0% 100%, 100% 100%)",
    shapeOutside: "polygon(0 0, 0% 100%, 100% 100%)",
    [emulatorScreen(theme)]: {
      width: 100,
      top: 31,
      left: 75,
      height: 53,
    },
    [mobileScreen(theme)]: {
      width: 87,
      top: 75,
      left: 27,
      height: 35.5,
    },
  },


  shape3Major: {
    width: 69,
    overflow: "hidden",
    top: 247,
    left: 180,
    position: "absolute",
    zIndex: 3,
    height: 70.3,
    // clipPath: "polygon(100% 0, 0% 100%, 100% 100%)",
    // shapeOutside: "polygon(100% 0, 0% 100%, 100% 100%)",
    [emulatorScreen(theme)]: {
      width: 65,
      top: 32,
      left: 266,
      height: 51.5,
    },
    [mobileScreen(theme)]: {
      width: 42.7,
      top: 94,
      left: 123,
      height: 35,
    },
  },

  shape4Major: {
    width: 65,
    overflow: "hidden",
    top: 286,
    left: 177,
    position: "absolute",
    zIndex: 3,
    height: 33,
    [emulatorScreen(theme)]: {
      width: 67.5,
      top: 81.5,
      left: 75,
      height: 45.5,
    },
    [mobileScreen(theme)]: {
      width: 39,
      top: 113,
      left: 120,
      height: 16,
    },
  },

  shape5Major: {
    width: 65.5,
    overflow: "hidden",
    top: 323,
    left: 177.5,
    position: "absolute",
    zIndex: 3,
    height: 32,
    clipPath: "polygon(0 0, 0% 100%, 100% 100%)",
    shapeOutside: "polygon(0 0, 0% 100%, 100% 100%)",
    [emulatorScreen(theme)]: {
      width: 54,
      top: 82.5,
      left: 144.5,
      height: 44.5,
    },
    [mobileScreen(theme)]: {
      width: 39,
      top: 132,
      left: 120,
      height: 16,
    },
  },

  shape6Major: {
    width: 209,
    overflow: "hidden",
    top: 215,
    left: 257,
    position: "absolute",
    zIndex: 3,
    height: 212,
    [emulatorScreen(theme)]: {
      clipPath: "polygon(0 4%, 50% 100%, 100% 4%)",
      width: 114,
      top: 81.5,
      left: 146,
      height: 44,
    },
    [mobileScreen(theme)]: {
      width: 131,
      top: 77.3,
      left: 169,
      height: 106,
    },
  },
});
export default styles;
